'use client'

import styled from 'styled-components'

export const ContainerTemplate = styled.div`
  background-color: var(--app-background-desktop);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 576px) {
    background-color: var(--app-background-mobile);
  }
`

export const ItemTemplate = styled.div`
  width: 100%;
  max-width: var(--container-max-width-default);
  display: flex;
  flex-direction: column;
  height: 100%;
`
